import { render, staticRenderFns } from "./filter-and-sort.vue?vue&type=template&id=0f6bc373&"
import script from "./filter-and-sort.vue?vue&type=script&lang=js&"
export * from "./filter-and-sort.vue?vue&type=script&lang=js&"
import style0 from "./filter-and-sort.vue?vue&type=style&index=0&id=0f6bc373&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports